import script from "./ListarFuncionarios.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarFuncionarios.vue?vue&type=script&setup=true&lang=js"

import "./ListarFuncionarios.vue?vue&type=style&index=0&id=61400eb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61400eb4"]])

export default __exports__